//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import Tag             from '@/helper/Tag';
import SagaStateHelper from '@/helper/SagaStateHelper';

function* getTagsFromEditor(context) {
    const editor = yield SagaStateHelper.selectFromState('tag', 'editor', context);

    return Tag.gatherLeafIri(editor.tagHierarchy);
}

export default {
    getTagsFromEditor,
};
